module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAVCAYAAACzK0UYAAAACXBIWXMAAAsSAAALEgHS3X78AAABFklEQVRIicXVv1HDMByG4Te59DCBQhWVZARtQBrVMRt4hGwATIBpo4YRkhFSqsOagA1EETnIig3Bjo7vzneW/OexZP1svPfk2hbb+s57z8R7T45I4ypgBahZJkAB69BcTXMgaf4fkcZV0rgiGxJe3Bp4HQCpX5EI6LzoghTR/u4M6QDerBZFel5fpHElMA/N2mrRRq4AFMBT1LUBvotxDCCNW4YbPkTde6uFOiEdAMD+oseHJXCT9B0AZbX4BJgstnVJe4hj8wJsGgBgBlQcV8P9iBvXwDvwbLX4SA8203UL7BLo0WpRjYBPmQKEoSmOc9lkSBH2I7mhVp3kgs4qvgcqr4p0QAf+/u1q5cffb1h1xGt+SL4A7+u+MOGTKG0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager/comment_reply_icon.png
// module id = kWMy
// module chunks = 0